module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av534-bf3f8e7ad1e30bee1b3ff0165a3e1aa1.jpg";